// extracted by mini-css-extract-plugin
export default {"root":"yy5XZLXLtAkFz1qVXFP_"};